export type ToastKind = "loading" | "success" | "warning" | "error" | "info"

export type ToastAction = {
  label: string
  onClick: () => void
}

export type Toast = {
  id: string
  kind: ToastKind
  title: string
  subtitle?: string
  action?: ToastAction
}

export const TOAST_DURATION_MS: Record<ToastKind, number | null> = {
  loading: null,
  info: 5000,
  success: 5000,
  warning: 10000,
  error: 10000,
}

export const MAX_TOASTS = 4

export type ToastStoreAction =
  | { type: "push"; toast: Toast }
  | { type: "update"; id: string; patch: Partial<Omit<Toast, "id">> }
  | { type: "dismiss"; id: string }

export function toastReducer(state: Toast[], action: ToastStoreAction): Toast[] {
  switch (action.type) {
    case "push":
      return capToasts([...state.filter((toast) => toast.id !== action.toast.id), action.toast])
    case "update":
      return capToasts(
        state.map((toast) => (
          toast.id === action.id
            ? { ...toast, ...action.patch }
            : toast
        )),
      )
    case "dismiss":
      return state.filter((toast) => toast.id !== action.id)
  }
}

function capToasts(toasts: Toast[]): Toast[] {
  const next = [...toasts]
  while (next.length > MAX_TOASTS) {
    const evictIndex = next.findIndex((toast) => toast.kind !== "loading")
    next.splice(evictIndex === -1 ? 0 : evictIndex, 1)
  }
  return next
}
